import React from 'react';
import {useWindowWidth} from '../../../helper';
import ImageHeader from '../head/ImageHeader';
import EventDatesCancelInfo from '../../sections/EventDatesCancelInfo';
import Description from '../../sections/Description';
import ChildEvents from '../../sections/ChildEvents';
import MapSingle from '../../map/MapSingle';
import HostInfo from '../../sections/HostInfo';
import DateInfo from '../../sections/DateInfo';
import CategoryList from '../../sections/CategoryList';
import TagList from '../../sections/TagList';
import Ticket from '../../sections/Ticket';
import PriceList from '../../sections/PriceList';

export default ({event}) => {
    const [width] = useWindowWidth();

    const {
        id,
        is_online_event,
        location,
        description,
        tags,
        host,
        categories,
        ticket_link,
        event_dates,
        event_dates_cancel_info,
        child_events,
        tag_as_child_events,
        prices,
        event_links,
    } = event;

    const showChildEvents = child_events.length > 0 || tag_as_child_events;

    return (
        <>
            <ImageHeader event={event} type="eventDetails" />
            <section className="directory_listing_detail_area single_area section-bg section-padding-strict">
                <div className="container">
                    <div className="row">

                        {width > 991 ?
                            <>
                                <div className="col-lg-8">
                                    {event_dates_cancel_info && (
                                        <EventDatesCancelInfo eventDatesCancelInfo={event_dates_cancel_info} />
                                    )}

                                    {description && (
                                        <Description
                                            description={description}
                                            eventLinks={event_links && event_links}
                                        />
                                    )}

                                    {showChildEvents && (
                                        <ChildEvents parentId={id} tagAsChildEvents={tag_as_child_events} />
                                    )}

                                    {!showChildEvents && !is_online_event && (
                                        <MapSingle location={location} title="event_location" forEvent={true} />
                                    )}
                                </div>

                                <div className="col-lg-4">
                                    <DateInfo eventDates={event_dates} />

                                    {prices.length > 0 && <PriceList prices={prices} />}

                                    {ticket_link && <Ticket ticketLink={ticket_link} />}

                                    {host && <HostInfo host={host} />}

                                    {categories.length > 0 && <CategoryList categories={categories} />}

                                    {tags.length > 0 && <TagList tags={tags} />}
                                </div>
                            </>
                            :
                            <>
                                <div className="col-12">
                                    {event_dates.length > 0 && <DateInfo eventDates={event_dates} />}

                                    {prices.length > 0 && <PriceList prices={prices} />}

                                    {ticket_link && <Ticket ticketLink={ticket_link} />}

                                    {event_dates_cancel_info && (
                                        <EventDatesCancelInfo eventDatesCancelInfo={event_dates_cancel_info} />
                                    )}

                                    {description && <Description description={description} eventLinks={event_links && event_links} />}

                                    {showChildEvents && (
                                        <ChildEvents
                                            parentId={id}
                                            tagAsChildEvents={tag_as_child_events}
                                            categories={categories}
                                        />
                                    )}

                                    {!showChildEvents && !is_online_event && (
                                        <MapSingle location={location} title="event_location" forEvent={true} />
                                    )}

                                    {host && <HostInfo host={host} />}

                                    {categories.length > 0 && <CategoryList categories={categories} />}

                                    {tags.length > 0 && <TagList tags={tags} />}
                                </div>
                            </>
                        }

                    </div>
                </div>
            </section>
        </>
    );
};
